import { Field } from 'formik';
import AddressComponent from '../AddressComponent';
import ErrorBoundary from '../ErrorBoundary';

export default function AddressSettings({ 
    errors, 
    touched, 
    values, 
    handleBlur, 
    handleChange, 
    sameAsBilling, 
    handleSameAsBilling 
}) {
    console.log("SameAsBilling:", sameAsBilling);
    
    return (
        <div className='space-y-4'>
            {/* Billing and Mailing Address Form Container */}
            <div className="bg-white rounded-lg border border-gray-200">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 p-6">
                    {/* Billing Address Section */}
                    <div className="space-y-4">
                        <h3 className="text-base font-medium text-gray-800 pb-2 border-b border-gray-100">
                            Billing Address
                        </h3>
                        <ErrorBoundary>
                            <AddressComponent
                                errors={errors}
                                touched={touched}
                                values={values}
                                handleChange={handleChange}
                                prefix="billAddr"
                                handleBlur={handleBlur}
                            />
                        </ErrorBoundary>
                    </div>

                    {/* Mailing Address Section */}
                    <div className="space-y-4">
                        {/* Mailing Address Header with Checkbox */}
                        <div className="flex items-center justify-between pb-2 border-b border-gray-100">
                            <h3 className="text-base font-medium text-gray-800">
                                Mailing Address
                            </h3>
                            <div className="flex items-center space-x-2">
                                <Field
                                    type="checkbox"
                                    className="h-4 w-4 text-teal-600 border-gray-300 rounded focus:ring-teal-500 focus:ring-2"
                                    name="sameAsBilling"
                                    onClick={(e) => handleSameAsBilling(e)}
                                    checked={sameAsBilling}
                                />
                                <label htmlFor="sameAsBilling" className="text-sm font-medium text-gray-700 cursor-pointer select-none whitespace-nowrap">
                                    Same as Billing
                                </label>
                            </div>
                        </div>

                        {/* Mailing Address Form - Only show when not same as billing */}
                        {!sameAsBilling && (
                            <div className="transition-all duration-200">
                                <ErrorBoundary>
                                    <AddressComponent
                                        disabled={sameAsBilling}
                                        errors={errors}
                                        touched={touched}
                                        values={values}
                                        handleChange={handleChange}
                                        prefix="mailAddr"
                                        handleBlur={handleBlur}
                                    />
                                </ErrorBoundary>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}